export default __webpack_public_path__ + "static/media/cause3.e76b25dd.png";